import { FC } from "react";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Block = styled.div`
  img {
    height: 40px;
  }
`;

interface IProps {
  isExtended: boolean;
  setIsExtended: (isExtended: boolean) => void;
}

const ExtendButton: FC<IProps> = ({ isExtended, setIsExtended }) => {
  const { t } = useTranslation();
  return (
    <Block>
      <a
        onClick={() => setIsExtended(!isExtended)}
      >
        <img
          src={`/images/icon-extend-${isExtended ? '2' : '1'}.png`}
          alt={t('student.student.column137')}
        />
      </a>
    </Block>
  );
}

export default ExtendButton;